import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const ButtonIcon = (props) => {
    const { icon, classNames = [], style = {}, onClick = () => null } = props;
    return (
        <div
            role="button"
            tabIndex="-1"
            className={['custom-icon-btn', ...classNames].join(' ')}
            style={style}
            onClick={onClick}
        >
            {icon}
        </div>
    );
};

ButtonIcon.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
    style: PropTypes.shape({}),
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
};

export default ButtonIcon;
